<template>
  <v-card outlined color="#e8eaf6" class="pa-1 mt-1" @click="isList ? navigateOrder(model.id) : false">
    <v-card-text class="pa-1 pt-0 pb-0">
      <v-row>
        <v-col cols="2" class="mt-1 pa-0 pl-1">
          <span class="body-2">{{ model.number }}</span>
          <br>
          <span class="body-2 d-inline-block text-truncate" style="max-width: 72px;">{{ model.salesreference }}</span>
        </v-col>
        <v-col :cols="isList ? 10 : 8" class="pa-0 pl-5">
          <v-row class="mt-1">
            <v-col cols="12" class="pa-0">
              {{ model.customername }}
            </v-col>
            <v-col cols="4" class="pa-0">
              {{ $t('message.order.orderedshort') }}: {{ model.orderdate | dateFormat }}
            </v-col>
            <v-col cols="4" class="pa-0">
              {{ $t('message.order.send_week') }}: {{ model.sendfrom_warehouse }}
            </v-col>
            <v-col cols="4" class="pa-0">
              {{ $t('message.order.shipmentshort') }}: {{ model.customershipment_name }}
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="!isList" cols="2" class="mt-4 pa-0 pr-2 text-right">
          <h4>
            -{{ model.pickedqty | absoluteNumber }}
          </h4>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    isList: {
      type: Boolean
    },
    model: {
      type: Object
    },
    type: {
      type: String
    }
  },
  methods: {
    navigateOrder (id) {
      if (this.type === 'store') this.$router.push(`/store_sale/${id}`)
      else this.$router.push(`/customer_orders/${id}`)
    }
  }
}
</script>
